import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function ModeManager() {

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {

    const token = localStorage.getItem("token");
    const mode = localStorage.getItem("mode");

    if (!token) return;

    if (
      mode === "business" &&
      !location.pathname.startsWith("/business")
    ) {
      navigate("/business/home", { replace: true });
    }

  }, []);

  return null;
}

export default ModeManager;